// import { useWindow } from "@lg-cfa/hooks";
// import { useWindow } from "@lg-cfa/hooks";
import { getCityName } from "@lg-cfa/utils";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { fireService } from "../../services/fire";
import { useFlowNavigation } from "../useFlowNavigation";

import { GetTariffParameterObjectResidentType, PageNames } from "@enums";
import {
    baseTariffState,
    optionTariffState,
    propertyStreetState,
} from "@states";
import { insuranceState, userDataState, userTypeState } from "@states/userData";
import {
    Address,
    GetTariffOptionsParameterObject,
    GetTariffParameterObject,
    MainGuarantee,
} from "@types";

export function useTariff() {
    const [propertyStreet] = useRecoilState(propertyStreetState);
    const userType = useRecoilValue(userTypeState);
    const data = useRecoilValue(userDataState);

    const chosenInsurance = useRecoilValue(insuranceState);

    const [baseTariff, setBaseTariff] = useRecoilState(baseTariffState);
    const [optionTariff, setOptionTariff] = useRecoilState(optionTariffState);

    const { navigateTo } = useFlowNavigation();

    const [baseLoading, setBaseLoading] = useState<boolean>(false);
    const [optionLoading, setOptionLoading] = useState<boolean>(false);

    const addressObject: Address = {
        city: getCityName(data.propertyCity),
        postalCode: Number(data.propertyPostalCode),
        street: propertyStreet?.name,
        streetId: propertyStreet?.id,
        houseNumber: data.propertyNumber,
        bus: data.propertyLetterBox,
    };

    const baseTariffObject: GetTariffParameterObject = {
        address: addressObject,
        risk: data.propertyRisk,
        residentType: userType as GetTariffParameterObjectResidentType,
        buildingType: data.housingType,
        rooms: {
            garages: data.garages,
            others: data.others,
            attics: data.attics,
            outbuildings: data.extras,
            basements: data.cellars,
        },
    };

    const getBaseTariff = async () => {
        setBaseLoading(true);
        try {
            const res = await fireService.getTariffV2(baseTariffObject);
            setBaseLoading(false);
            setBaseTariff(res);
        } catch (err) {
            console.error(err);
            setBaseLoading(false);
            navigateTo(PageNames.TechnicalDifficulties);
        }
    };

    const selectedMainGuarantee = baseTariff?.mainGuarantees?.find(
        (guarantee: MainGuarantee) =>
            guarantee.name?.toLowerCase() === chosenInsurance?.key,
    );

    const getOptionTariff = async () => {
        if (!baseTariff) await getBaseTariff();

        if (!selectedMainGuarantee) return;

        const optionTariffObject: GetTariffOptionsParameterObject = {
            quoteInput: baseTariffObject,
            mainGuarantee: selectedMainGuarantee,
        };

        setOptionLoading(true);

        try {
            const res =
                await fireService.getTariffV2Options(optionTariffObject);
            setOptionLoading(false);
            setOptionTariff(res ?? []);
        } catch (err) {
            console.error(err);
            setOptionLoading(false);
            navigateTo(PageNames.TechnicalDifficulties);
        }
    };

    useEffect(() => {
        if (!baseTariff) {
            getBaseTariff();
        }
        // eslint-disable-next-line
    }, [baseTariff]);

    return {
        baseLoading,
        optionLoading,
        baseTariff,
        optionTariff,
        getOptionTariff,
    };
}
